import API from "./api";
export const importProducts = async (formData) => {
  const response = await API.post("/import/products", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const importPackages = async (formData) => {
  const response = await API.post("/import/packages", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
